/**
 *  Add product to cart drawer
 */
class AddToCart extends HTMLElement {
  /**
   *
   * @param {HTMLElement} productForm product add to cart form
   */
  constructor() {
    super();
    this.SELECTORS = {
      formSubmit: '[data-product-cart-submit]',
      inputID: 'input[name="id"]',
      inputQuantity: 'input[name="quantity"]',
    };
    this.cacheDOM();
    this.eventListener();
  }

  /**
   * Class method to cache needed elements
   */
  cacheDOM() {
    this.refs = {};
    this.refs.theme = globalThis?.theme;
    this.refs.productForm = this.querySelector('form');
    this.refs.productFormSubmit = this.refs.productForm?.querySelector(this.SELECTORS.formSubmit);
    this.refs.inputID = this.refs.productForm?.querySelector(this.SELECTORS.inputID);
  }

  /**
   * Class method to listening for events
   */
  eventListener() {
    if (typeof (this.refs.productForm) !== 'undefined' && this.refs.productForm != null) {
      this.refs.productForm.addEventListener('submit', (e) => {
        e.preventDefault();
      });
    }
    if (typeof (this.refs.productFormSubmit) !== 'undefined' && this.refs.productFormSubmit != null) {
      this.refs.productFormSubmit.addEventListener('click', () => {
        this.addProductToDrawer();
      });
    }
  }

  /**
   *  Class method to call addToCart method from cartDrawer
   */
  async addProductToDrawer() {
    const id = this.refs.inputID.value;
    const formData = new FormData(this.refs.productForm);
    const quantity = formData.get('quantity');
    let response;
    try {
      const request = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id,
            quantity,
          }],
        }),
      });
      response = await request.json();
      // open drawer
      document.querySelectorAll('.js-drawer-open-right-link').forEach((item) => item.click());
      return response;
    } catch (error) {
      console.error(error);
    }
    return response;
  }
}

customElements.define('add-to-cart', AddToCart);
